import {Pipe, PipeTransform} from '@angular/core';
import {NgxFiltersService} from "../ngx-filters.service";
import {Filter} from "../ngx-types";

@Pipe({
  name: 'conditionFilter'
})
export class ConditionFilterPipe implements PipeTransform {
  constructor(private filterService: NgxFiltersService) {
  }

  transform(value: any[], ...args: any[]): any[] {
    if (value && args && args[0]) {
      const filter: Filter = args[0];
      let conditions = this.filterService.conditionSource.filter(z => z.types.includes(filter.type));
      if (filter.conditionOperators) {
        conditions = conditions.filter(w => filter.conditionOperators.includes(w.key));
      }
      return conditions;
    }
    return [];
  }
}
